<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <!-- <div class="col-1 text-right">
                <label for="" style="color:transparent">Todas</label>
                <el-checkbox
                  label="Todas"
                  v-model="formData.allFarms"
                  @change="allFarmsChange"
                  class="select-primary custom-width-select mt-2"
                >
                </el-checkbox>
              </div> -->
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  clearable
                  multiple
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="formData.farm_id"
                  :placeholder="`${$t('common_words.select')}...`"
                  @change="
                    selectAllFromSelect('formData.farm_id', farms);
                    getYears();
                  "
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-2">
                <label>{{ $t('samples.element') }} *</label>
                <br />
                <el-select
                  clearable
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-type shadow-sm"
                  size="large"
                  v-model="formData.symbol"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in elements"
                    class="select-primary"
                    :value="option.symbol"
                    :label="option.symbol"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-2">
                <label>{{ $t('common_words.date_range') }}</label>
                <br />
                <el-select
                  clearable
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="formData.useRange"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in [
                      { name: 'Semanal', id: 1 },
                      { name: 'Intervalo', id: 2 },
                    ]"
                    class="select-primary"
                    :value="option.name"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="row p-3">
              <div
                class="col-12 col-sm-6 col-md-3"
                v-if="formData.useRange == 'Intervalo'"
              >
                <label for="">{{ $t('common_words.date') }}: </label>
                <el-date-picker
                  v-if="renderComponent"
                  class="shadow-sm"
                  :clearable="false"
                  v-model="rangeDate"
                  type="daterange"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                  :align="'right'"
                >
                </el-date-picker>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-2"
                style="padding-right: 0"
                v-if="formData.useRange == 'Semanal'"
              >
                <label for="">{{ $t('common_words.date') }}: </label>
                <el-select
                  :placeholder="`${$t('common_words.select')}...`"
                  clearable
                  @clear="formData.year = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="formData.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in years"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-2"
                style="padding-top: 32px"
                v-if="formData.year_sel_init && formData.useRange == 'Semanal'"
              >
                <el-select
                  clearable
                  @clear="formData.week_sel_init = null"
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="formData.week_sel_init"
                >
                  <el-option
                    v-for="(option, index) in 53"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div class="row">
        <div class="col-12 map-climate">
          <div
            ref="map"
            class="map"
            v-if="renderComponent"
            style="height: 800px"
          ></div>
          <div
            id="toolbarDiv"
            class="esri-component esri-widget"
            v-if="renderComponent"
          >
            <button
              id="distance"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
              style="margin-bottom: 10px"
              :title="$t('common_words.distance_measurement_tool')"
            ></button>
            <button
              id="area"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
              style="margin-bottom: 10px"
              :title="$t('common_words.area_measurement_tool')"
            ></button>
            <button
              id="clear"
              class="action-button esri-widget--button esri-interactive esri-icon-trash"
              style="margin-bottom: 10px"
              :end-placeholder="$t('common_words.final_date')"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import SweetAlert from 'src/class/Alerts';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import { Checkbox } from 'element-ui';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  components: {
    [Checkbox.name]: Checkbox,
  },

  computed: {
    calendars() {
      if (this.formData.farm_id) {
        let calendars = [];
        this.farms.forEach((element) => {
          this.formData.farm_id.forEach((elFarm) => {
            if (element.id == elFarm) {
              calendars = element.calendars;
            }
          });
        });

        return calendars;
      } else {
        return [];
      }
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },
  data() {
    return {
      center: {
        lat: 10.947212,
        lng: -74.203901717,
      },
      activeName: '1',
      formData: {
        // report_type: null,
        year_sel_init: null,
        week_sel_init: null,
        useRange: 'Semanal',
        symbol: null,
        init: null,
        end: null,
        business_id: [],
        farm_id: [],
        allFarms: false,
        // farm_name: null
      },
      options: {
        0: { label: i18n.t('samples.ground_chemical'), value: 'quimica' },
        1: { label: i18n.t('samples.ground_textures'), value: 'textura' },
      },
      elements: [],
      renderComponent: true,
      farms: [],
      mapData: {},
      kmlLayer: null,
      map: null,
      reports: null,
      years: [],
      valueCollapse: null,
    };
  },

  mixins: [
    MixinPermissions,
    MixinDatePicker,
    MixinArcgisMap,
    mixinMasters,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    validate() {
      this.loadReport();
    },

    allFarmsChange() {
      if (this.formData.allFarms) {
        this.formData.farm_id = this.farms.map((farm) => farm.id);
      } else {
        this.formData.farm_id = [];
      }
    },

    getYears() {
      let data = {
        farms: this.formData.farm_id,
        route: 'gis/samples/minyear',
      };

      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            this.years = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'gis/samples/gissamples';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            this.reports = response.data.data;
            this.loadMap('filtrar');
          }
          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    loadData() {
      let data = {
        farms: this.formData.farm_id,
        symbol: this.formData.symbol,
        useRange: this.formData.useRange,
      };
      switch (this.formData.useRange) {
        case 'Semanal':
          data.init =
            parseInt(this.formData.year_sel_init) * 100 +
            parseInt(this.formData.week_sel_init);
          break;
        case 'Intervalo':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');

          break;
      }
      return data;
    },

    loadMap(where) {
      this.renderComponent = false;
      this.showHideLoading(true);
      let namesFiles = [];
      let other_values = [];
      let centers = [];

      for (let index = 0; index < this.farms.length; index++) {
        if (this.formData.farm_id.includes(this.farms[index].id)) {
          this.center = {
            lat: this.farms[index].latitude,
            lng: this.farms[index].longitude,
          };

          centers.push(this.center);

          if (
            this.farms[index].other_values &&
            JSON.parse(this.farms[index].other_values).files
          ) {
            JSON.parse(this.farms[index].other_values).files.forEach(
              (element) => {
                namesFiles.push(this.farms[index].id + '/' + element);
              }
            );
          }
        }
      }

      this.$nextTick(() => {
        this.renderComponent = true;
        if (where == 'created') {
          this.loadMapMuestras(
            true,
            centers,
            ['Lotes'],
            namesFiles,
            this.reports,
            '',
            true
          );
        } else if (where == 'filtrar') {
          this.loadMapMuestras(
            false,
            centers,
            ['Lotes'],
            namesFiles,
            this.reports,
            '',
            true
          );
        }
        this.showHideLoading();

        setTimeout(() => {
          document.getElementById('toolbarDiv').style =
            'top: 19% !important;right: 30px;';
        }, 10);
      });
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('gis/samples/getelements'),
      ])
        .then((response) => {
          this.farms = this.concatAll(response[0].data.data);
          this.elements = response[1].data;
          this.loadMap('created');
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning('error');
        });
    } else {
      this.showHideLoading();
    }

    // Axios.getMasters('calendars/getyearsbusiness').then((response) => {
    // this.years = Object.keys(response.data).reverse();
    // this.showHideLoading()
    // })
  },

  mounted() {
    this.selectedItemOnMenu('gis');
  },

  destroyed() {
    this.deselectedItemOnMenu('gis');
  },
};
</script>

<style scoped>
#toolbarDiv {
  top: 12% !important;
  margin-top: 0px;
  padding-top: 0px;
}
</style>
